import Header from "../Components/Header";
import Sidebar from "../Components/Sidebar";
import { Outlet } from "react-router-dom";

export default function DashboardPage() {
  return (
    <>
      <Header />
      <div className="h-[90vh] p-4 bg-primary">
        <div className="grid grid-cols-12 gap-3 h-full">
          <div className="col-span-2 md:col-span-4 lg:col-span-2 bg-dashboard rounded-xl">
            <Sidebar />
          </div>
          <div className="col-span-10 md:col-span-8 lg:col-span-10 max-h-full overflow-y-auto">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
}
